var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-col",
    { attrs: { xl: "4", lg: "6", md: "12", sm: "6", cols: "12" } },
    [
      _c(
        "badge",
        {
          staticClass: "ml-0 mr-2 document-badge w-100 mb-2",
          class: { "document-badge-editing": _vm.editing },
          staticStyle: { "text-transform": "unset" },
          attrs: { type: "light" },
        },
        [
          _c(
            "div",
            { staticClass: "vertical-center justify-content-between" },
            [
              _c(
                "span",
                {
                  staticClass: "mb-0 text-truncate un-selectable",
                  attrs: { title: _vm.document.classification },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.document.classification) +
                      " \n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.editing
                ? _c(
                    "span",
                    { staticClass: "request-trash pl-3" },
                    [
                      _c("inline-prompt", {
                        attrs: { "action-type": "delete" },
                        on: { accept: _vm.handleDeleteDocument },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "mt-1 vertical-center document-description-wrapper",
              class: { "truncated-document-description": !_vm.showMore },
            },
            [
              _c("editable-description", {
                attrs: {
                  description: _vm.document.description,
                  label: false,
                  "force-edit": _vm.editing,
                  "no-margin": "",
                },
                on: { save: _vm.handleEditDescription },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var newDescription = ref.newDescription
                      var handleClickOutside = ref.handleClickOutside
                      var handleDescriptionChange = ref.handleDescriptionChange
                      return [
                        _c("textarea", {
                          staticClass:
                            "form-control form moregage-data description-input mb-0",
                          attrs: {
                            id: _vm.labelValue,
                            type: "text",
                            placeholder: _vm.$t(
                              "documents.writeDocumentDescription"
                            ),
                            rows: "4",
                          },
                          domProps: { value: newDescription },
                          on: {
                            blur: handleClickOutside,
                            keypress: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              $event.stopPropagation()
                              return handleClickOutside.apply(null, arguments)
                            },
                            input: handleDescriptionChange,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "d-none",
                            attrs: { for: _vm.labelValue },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("documents.writeDocumentDescription")
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _vm.showReadMoreButton
                ? _c("icon", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.right",
                        value: _vm.showMoreButtonText,
                        expression: "showMoreButtonText",
                        modifiers: { right: true },
                      },
                    ],
                    staticClass:
                      "small clickable small text-primary show-more-button pl-1",
                    attrs: { name: _vm.showMoreButtonIcon },
                    on: { click: _vm.toggleShowMore },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }